import { Address } from 'app/class/address';
import { Cover } from 'app/class/cover';
import { CoverSelect } from 'app/class/cover-select';

export class House {
    supplementaryEnergyCode: string;
    wallConstructionCode: string;
    constructionYear?: number;
    livingArea?: number;
    basementArea?: number;
    usedForRental?: boolean;
    usageCode: string;
    roofTypeCode: string;
    heatingCode: string;

    deductibleId: string;
    address: Address;
    covers: CoverSelect[];

    airRecycling: boolean;
    garageArea: number;
    geothermal: boolean;
    heatPump: boolean;
    pelletStokers: boolean;
    solarCellsGround: boolean;
    solarCellsRoof: boolean;
    solarPanels: boolean;
    utilizedBasementArea?: number;

    isBBRChecked: boolean;

    adoptAddress = true;
    eventDate?: Date;

    constructor() {
        this.supplementaryEnergyCode = null;
        this.wallConstructionCode = null;
        this.constructionYear = null;
        this.livingArea = null;
        this.basementArea = null;
        this.usageCode = null;
        this.roofTypeCode = null;
        this.heatingCode = null;
        this.deductibleId = '';
        this.usedForRental = null;
        this.address = {
            addressId: '',
            addressText: '',
        };
        this.airRecycling = false;
        this.garageArea = null;
        this.geothermal = false;
        this.heatPump = false;
        this.pelletStokers = false;
        this.solarCellsGround = false;
        this.solarCellsRoof = false;
        this.solarPanels = false;
        this.utilizedBasementArea = null;
        this.isBBRChecked = false;
    }
}
